import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import DateFnsUtils from "@date-io/date-fns";
import { materialTableLocalization } from "../../utils/materialTableLocalization";

// core components
import Grid from "@material-ui/core/Grid";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";

import Button from "components/CustomButtons/Button.js";
import CircularProgress from "@material-ui/core/CircularProgress";
import MuiAlert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import { green, blue, blueGrey } from "@material-ui/core/colors";
/** Componentes Modal*/
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Select from "@material-ui/core/Select";

import ModalLotesCliente from "views/Clientes/ModalLotesCliente";
import useConsultaClientes from "../../hooks/useConsultaClientes";
import useMessage from "../../hooks/useMessage";
import { validateClientForm } from "../../utils/validateClientForm";

import clsx from "clsx";
import MenuItem from "@material-ui/core/MenuItem";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker
} from "@material-ui/pickers";

// core components

// material-ui
import { makeStyles } from "@material-ui/core/styles";
import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.js";

const useStyles = makeStyles(theme => ({
  ...dashboardStyle,
  cardTitle: {
    marginTop: "0",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none"
  },
  root: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    color: "#999 !important",
    fontWeight: "400 !important",
    fontSize: "14px !important",
    lineHeight: "1.42857 !important",
    letterSpacing: "unset !important",
    padding: "10px",
    marginRight: "10px"
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12
  },
  buttonSuccess: {
    backgroundColor: green[500],
    "&:hover": {
      backgroundColor: green[700]
    }
  },
  buttonLimpiar: {
    backgroundColor: blueGrey[500],
    "&:hover": {
      backgroundColor: blueGrey[700]
    }
  },
  buttonRegistra: {
    backgroundColor: blue[500],
    "&:hover": {
      backgroundColor: blue[700]
    }
  },
  separacion: {
    padding: "10px",
    marginRight: "10px"
  },
  rootB: {
    "&:before": {
      borderBottomColor: "lightgrey !important"
    },
    "&:after": {
      borderBottomColor: "lightgrey !important"
    }
  },
  container: {
    textAlign: "center"
  },
  content: {
    display: "inline-flex",
    padding: "10px",
    alignItems: "center"
  },
  paddingBottomCard: {
    paddingBottom: "40px"
  },
  marginRight: {
    marginRight: "10px"
  },
  marginBottom: {
    marginBottom: "50px"
  },
  formControl: {
    marginTop: theme.spacing(3.5),
    minWidth: "100%"
  },
  formControlMid: {
    marginTop: theme.spacing(3.5),
    minWidth: "50%"
  },
  formControlSeven: {
    marginTop: theme.spacing(3.5),
    minWidth: "70%"
  },
  checkControl: {
    marginTop: theme.spacing(5)
  },
  formControlDate: {
    marginTop: theme.spacing(1.5),
    minWidth: "100%"
  },
  selectEmpty: {
    marginTop: theme.spacing(2)
  },
  showSpinner: {
    float: "right",
    display: "block"
  },
  hideSpinner: {
    display: "none"
  },
  disabledSelect: {
    opacity: "0.5 !important"
  },
  enableSelect: {
    opacity: "1 !important"
  },
  sectionHeader: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    fontWeight: 500
  }
}));
export default function ConsultaClientes() {
  const classes = useStyles();

  const [data, setData] = useState([]);
  const [column] = useState([
    {
      title: "ID cliente",
      field: "ID_CLIENTE",
      type: "numeric",
      editable: "never"
    },
    {
      title: "Nombre",
      field: "NOMBRES",
      type: "string"
    },
    {
      title: "Apellido paterno",
      field: "APELLIDO_PATERNO",
      type: "string"
    },
    {
      title: "Apellido materno",
      field: "APELLIDO_MATERNO",
      type: "string"
    },
    {
      title: "Fecha de nacimiento",
      field: "FECHA_NACIMIENTO",
      type: "date",
      editable: "never",
      render: rowData => {
        if (!rowData.FECHA_NACIMIENTO) return "";
        const d = new Date(rowData.FECHA_NACIMIENTO);
        if (isNaN(d.getTime())) return "";
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();
        return `${day}/${month}/${year}`;
      }
    },
    {
      title: "Clave elector",
      field: "CLAVE_ELECTOR",
      type: "string",
      editable: "never"
    }
  ]);

  /*metodos on row selection */
  const [selectedRow, setSelectedRow] = useState();
  const [highlightedClientId, setHighlightedClientId] = useState(null);

  const onSelectionChange = selectedRows => {
    console.log(selectedRows);
  };

  const [modalLote, setModalLote] = useState(false);

  const {
    opensnack,
    typesnackbar,
    message,
    handleMuestraSnack,
    handleClosesSnack
  } = useMessage();

  const {
    lotesCliente,
    setLotesCliente,
    getLotesxCliente ,

    getMovimientosxLote,
    movimientosLote,
    setMovimientosLote,

    getAmortizacionxLote,
    amortizacionxlote,
    setAmortizacionxLote
  } = useConsultaClientes({handleMuestraSnack});


  const onRowClick = (e, clickedRow) => {


    setSelectedRow(clickedRow);
    
    getLotesxCliente(clickedRow.ID_CLIENTE);
    
    setModalLote(true);
  };

  /*fin metodos on row selection
   */

  const traeToken = async () => {
    let header = {
      method: "POST",
      body: JSON.stringify({
        usuario: process.env.REACT_APP_USER,
        pass: process.env.REACT_APP_PASS
      }),
      headers: { "Content-Type": "application/json" }
    };

    let response = await fetch(
      process.env.REACT_APP_URL_API + "loginapi",
      header
    );

    let dataResponse = await response.json();
    return dataResponse;
  };

  const traeencabezadocontoken = (token, body) => {
    let header = {
      method: "POST",
      body: body,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token
      }
    };
    return header;
  };

  const [numeroCliente, setNumeroCliente] = useState("");
  const [apellidoP, setApellidoP] = useState("");
  const [apellidoM, setApellidoM] = useState("");
  const [nombres, setNombres] = useState("");
  const [actualiza, setactualiza] = useState(false);

  const inputChange = event => {
    try {
      switch (event.target.id) {
        case "numeroCliente":
          const onlyNums = event.target.value.replace(/[^0-9]/g, "");
          setNumeroCliente(onlyNums);
          break;
        case "apellidoP":
          const onlyLetters = event.target.value.replace(/[^a-zA-Z]/g, "");
          setApellidoP(onlyLetters);
          break;
        case "apellidoM":
          const onlyLettersM = event.target.value.replace(/[^a-zA-Z]/g, "");
          setApellidoM(onlyLettersM);
          break;
        case "nombres":
          const onlyLettersN = event.target.value.replace(/[^a-zA-Z]/g, "");
          setNombres(onlyLettersN);
          break;
        default:
          break;
      }
    } catch (error) {}
  };

  useEffect(() => {
    if (!opensnackok) {
      setLoading(false);
      // handleClose();
    }
  }, [opensnackok]);

  useEffect(() => {}, [actualiza]);

  /* inicio snack bar */
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  const [mensajeSnack, setmensajeSnack] = useState("Exitoso");

  const [opensnackok, setOpensnackok] = React.useState(false);

  const handleClicksnackok = () => {
    setOpensnackok(true);
  };

  const handleClosesSnackOk = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpensnackok(false);
  };
  /* snack bar */

  const ejecutaapi = async (token, metodo, body) => {
    let header = traeencabezadocontoken(token, body);
    let response = await fetch(process.env.REACT_APP_URL_API + metodo, header);
    if (!response.ok) {
      let errorData;
      try { errorData = await response.json(); } catch (e) { errorData = {}; }
      return { Ok: false, error: errorData.error || "Error HTTP " + response.status };
    }
    let dataResponse = await response.json();
    return dataResponse;
  };

  const limpiar = event => {
    setNumeroCliente("");
    setApellidoP("");
    setApellidoM("");
    setNombres("");
    setLoading(false);
  };

  const handeSubmit = (eventOrClienteId) => {
    //event.preventDefault();

    let usuario = localStorage.getItem("user");
    let token = "";
    let numCliente = 0;
    let body;

    if (typeof eventOrClienteId === 'number' && eventOrClienteId > 0) {
      // Llamada post-inserción: buscar por ID directo
      numCliente = eventOrClienteId;
      body = JSON.stringify({
        idCliente: numCliente,
        nombre: "",
        apellidoP: "",
        apellidoM: ""
      });
    } else {
      // Llamada manual desde formulario de búsqueda
      if (numeroCliente > 0) {
        numCliente = numeroCliente;
      }
      body = JSON.stringify({
        idCliente: numCliente,
        nombre: nombres,
        apellidoP: apellidoP,
        apellidoM: apellidoM
      });
    }

    traeToken().then(result => {
      if (result.Ok) {
        token = result.token;

        ejecutaapi(token, "obtienecliente", body).then(result => {
          if (result.Ok && result.result && result.result[0]) {
            setData(result.result[0]);
            if (result.result[0].length === 0) {
              setmensajeERROR("Lista vacía, favor de validar los datos");
              handleClickSnackError();
            
            } else {
              setmensajeSnack("Lista actualizada");
              handleClicksnackok();
            }
            setactualiza(true);
            setLoading(false);
          } else {
            if (result.message == undefined || result.message == "") {
              handleClickSnackError();
              setLoading(false);
            } else {
              handleClickSnackError();
              setLoading(false);
            }
          }
        });
      }
    });
  };

  /*circulo carga */
  const [loading, setLoading] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const timer = React.useRef();

  const buttonClassname = clsx({
    [classes.buttonSuccess]: success
  });
  const buttonClassnameLimpiar = clsx({
    [classes.buttonLimpiar]: success
  });
  const buttonClassnameRegistra = clsx({
    [classes.buttonRegistra]: success
  });
  React.useEffect(() => {
    return () => {
      clearTimeout(timer.current);
    };
  }, []);

  const handleButtonClick = () => {
    if (!loading) {
      setLoading(true);
      setSuccess(false);
    }
  };
  /*circulo carga */

  /*  snack bar error*/

  const [openSnackError, setOpenSnackError] = useState(false);
  const [mensajeERROR, setmensajeERROR] = useState("Error");

  const handleClickSnackError = () => {
    setOpenSnackError(true);
  };

  const handleClosesSnackError = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnackError(false);
  };
  /* fin snack bar error*/

  /**Modal  cLIENTE */
  const [numeroClienteActualiza, setnumeroClienteActualiza] = useState("");
  const [modal, setModal] = useState(false);
  const [modaltitle, setModalTitle] = useState("");
  const [esUpdate, setesUpdate] = useState(false);




  const handleClickOpen = (event, data, type) => {
    switch (type) {
      case "add":
        setesUpdate(false);
        setModalTitle("Insertar cliente");
        setModal(true);
        break;
      case "update":
        // setidPersonal(id);
        setesUpdate(true);
        setModalTitle("Actualizar cliente");
        setModal(true);
        break;
    }
  };

  /*
PROPIEDADES MODAL INSERTA
*/

  /*sexo*/
  const [sexo, setsexo] = React.useState("");

  const handleChangesexo = event => {
    setsexo(event.target.value);
  };

  /*iniciofecha ingreso*/

  const [fechainicioservicio, setfechainicioservicio] = useState(new Date());
  const [fechainicioservicioParse, setfechainicioservicioParse] = useState("");
  const parseafechainicioServicio = date => {
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear().toString();

    if (month < 10) {
      month = `0${month}`;
    }
    if (day < 10) {
      day = `0${day}`;
    }

    setfechainicioservicioParse(`${day}-${month}-${year}`);
  };

  const handledfechainicioservicio = date => {
    setfechainicioservicio(date);
    parseafechainicioServicio(date);
  };
  /*finfecha ingreso*/

  const [modapellidoP, setModApellidoP] = useState("");
  const [modapellidoM, setModApellidoM] = useState("");
  const [modnombres, setModNombres] = useState("");


  const [modTelefono, setmodTelefono] = useState("");
  const [modTeleSinGion, setmodTeleSinGion] = useState("");

  const [modTelefonoMov, setmodTelefonoMov] = useState("");
  const [modTeleSinGionMov, setmodTeleSinGionMov] = useState("");

  const [modClaveElector, setmodClaveElector] = useState("");


  const [modEmail, setmodEmail] = useState("");
  const [modDireccion, setmodDireccion] = useState("");

  const [formErrors, setFormErrors] = useState({});

  //FIN PROPIEDADES MODAL INSERTA
  const handleClose = () => {
    setModal(false);
    setModApellidoP("");
    setModApellidoM("");
    setModNombres("");
    setmodClaveElector("");
    setmodDireccion("");
    setmodEmail("");
    setmodTelefono("");
    setmodTeleSinGion("");
    setmodTelefonoMov("");
    setmodTeleSinGionMov("");
    setsexo("");
    setfechainicioservicio(new Date());
    setfechainicioservicioParse("");
    setFormErrors({});
  };
  //metodos MODAL

  const manejoErrores = error => {
    let msjErr = "Error al insertar cliente";

    switch (error.errno) {
      case 1062:
        msjErr = "Registro Duplicado";
        break;

      default:
        break;
    }
    return msjErr;
  };

  // Inline validation for a single field
  const validateField = (fieldName, value, allFields) => {
    const formData = {
      nombre: modnombres,
      apellidoP: modapellidoP,
      fechaNacimiento: fechainicioservicio,
      claveElector: modClaveElector,
      email: modEmail,
      telefonoFijo: modTeleSinGion,
      telefonoMovil: modTeleSinGionMov,
      ...allFields,
      [fieldName]: value
    };
    const errors = validateClientForm(formData);
    setFormErrors(prev => {
      const next = { ...prev };
      if (errors[fieldName]) {
        next[fieldName] = errors[fieldName];
      } else {
        delete next[fieldName];
      }
      return next;
    });
  };

  // Check if required fields are filled for button disable logic
  const requiredFieldsEmpty =
    !modnombres.trim() ||
    !modapellidoP.trim() ||
    !fechainicioservicio ||
    !modClaveElector.trim();

  const isAceptarDisabled =
    loading || requiredFieldsEmpty;

  // Format date as dd-MM-yyyy
  const formatDateForBackend = date => {
    if (!date || !(date instanceof Date) || isNaN(date.getTime())) return "";
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear().toString();
    if (month < 10) month = `0${month}`;
    if (day < 10) day = `0${day}`;
    return `${day}-${month}-${year}`;
  };

  const insertaCliente = e => {
    // Run full validation as last barrier
    const fullErrors = validateClientForm({
      nombre: modnombres,
      apellidoP: modapellidoP,
      fechaNacimiento: fechainicioservicio,
      claveElector: modClaveElector,
      email: modEmail,
      telefonoFijo: modTeleSinGion,
      telefonoMovil: modTeleSinGionMov
    });
    if (Object.keys(fullErrors).length > 0) {
      setFormErrors(fullErrors);
      setLoading(false); // desbloquear botón si hay errores de validación
      return;
    }

    traeToken().then(
      result => {
        if (result.Ok) {
          let body = JSON.stringify({
            nombre: modnombres,
            apellidoP: modapellidoP,
            apellidoM: modapellidoM || null,
            fechaNacimiento: formatDateForBackend(fechainicioservicio),
            claveElector: modClaveElector,
            email: modEmail || null,
            telefonoFijo: modTeleSinGion || null,
            telefonoMovil: modTeleSinGionMov || null,
            direccion: modDireccion || null,
            sexo: sexo || null
          });

          ejecutaapi(result.token, "insertacliente", body).then(
            inserta => {
              if (inserta.Ok) {
                const nuevoId = inserta.result && inserta.result[0] && inserta.result[0][0] && inserta.result[0][0].pIdCliente;
                if (!nuevoId) {
                  setmensajeERROR("No se pudo obtener el ID del cliente insertado");
                  handleClickSnackError();
                  setLoading(false);
                  return;
                }
                setmensajeSnack("Cliente insertado con éxito");
                handleClose();
                handleClicksnackok();
                setHighlightedClientId(nuevoId);
                handeSubmit(nuevoId);
                setLoading(false);
                // Si viene del flujo de contratación, guardar ID y regresar
                if (sessionStorage.getItem("retorno_contrato")) {
                  sessionStorage.removeItem("retorno_contrato");
                  sessionStorage.setItem("nuevo_cliente_id", nuevoId);
                  setTimeout(() => {
                    window.location.href = "/admin/Contract";
                  }, 1500);
                }
              } else {
                setmensajeERROR(() => manejoErrores(inserta.error));
                setLoading(false);
                handleClickSnackError();
              }
            },
            error => {
              setmensajeERROR(error.message);
              setLoading(false);
              handleClickSnackError();
            }
          );
        }
      },
      error => {
        setmensajeERROR(error.message);
        setLoading(false);
        handleClickSnackError();
      }
    );
  };

  const inputChangeModal = event => {
    try {
      switch (event.target.id) {
        case "telFijoMod":
          const textoAjustado = event.target.value
            .replace(/[^0-9]/g, "")
            .replace(/(\d{5})(\d{4})/, function(regex, arg1, arg2) {
              return arg1 + "-" + arg2;
            });

          setmodTelefono(textoAjustado);
          setmodTeleSinGion(event.target.value.replace(/[^0-9]/g, ""));
          validateField("telefonoFijo", event.target.value.replace(/[^0-9]/g, ""));
          break;
          case "telMovilMod":
            const textoAjustadoMov = event.target.value
              .replace(/[^0-9]/g, "")
              .replace(/(\d{5})(\d{4})/, function(regex, arg1, arg2) {
                return arg1 + "-" + arg2;
              });
  
              setmodTelefonoMov(textoAjustadoMov);
            setmodTeleSinGionMov(event.target.value.replace(/[^0-9]/g, ""));
            validateField("telefonoMovil", event.target.value.replace(/[^0-9]/g, ""));
            break;
        case "apellidoPmod":
          const onlyLetters = event.target.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s]/g, "");
          setModApellidoP(onlyLetters);
          validateField("apellidoP", onlyLetters);
          break;
        case "apellidoMmod":
          const onlyLettersM = event.target.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s]/g, "");
          setModApellidoM(onlyLettersM);
          break;
        case "nombreMod":
          const onlyLettersN = event.target.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s]/g, "");
          setModNombres(onlyLettersN);
          validateField("nombre", onlyLettersN);
          break;
        default:
          break;
      }
    } catch (error) {}
  };

  const onrRowSelect = e => {
    console.log(e);
  };

  //FIN METODOS MODAL
  return (
    <>
      <Card>
        <CardHeader color="primary">
          <h4 className={classes.cardTitle}> Clientes </h4>{" "}
        </CardHeader>{" "}
        <CardBody>
        

          <Typography variant="body2" style={{ marginBottom: 16, color: "#666" }}>
            Ingresa alguno de los parámetros de búsqueda.
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth>
                <InputLabel required={false} id="desarrollo-label">
                  Número de cliente
                </InputLabel>

                <CustomInput
                  id="numeroCliente"
                  disabled={loading}
                  type="number"
                  onChange={e => {
                    inputChange(e);
                  }}
                  formControlProps={{
                    fullWidth: true
                  }}
                  labelProps={{
                    required: true
                  }}
                  inputProps={{
                    maxLength: 50
                  }}
                  attributes={{
                    value: numeroCliente
                  }}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth>
                <InputLabel required={false} id="desarrollo-label">
                  Nombres
                </InputLabel>

                <CustomInput
                  id="nombres"
                  disabled={loading}
                  onChange={e => {
                    inputChange(e);
                  }}
                  formControlProps={{
                    fullWidth: true
                  }}
                  labelProps={{
                    required: true
                  }}
                  inputProps={{
                    maxLength: 50
                  }}
                  attributes={{
                    value: nombres
                  }}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth>
                <InputLabel required={false} id="desarrollo-label">
                  Apellido Paterno
                </InputLabel>

                <CustomInput
                  id="apellidoP"
                  disabled={loading}
                  onChange={e => {
                    inputChange(e);
                  }}
                  formControlProps={{
                    fullWidth: true
                  }}
                  labelProps={{
                    required: true
                  }}
                  inputProps={{
                    maxLength: 50
                  }}
                  attributes={{
                    value: apellidoP
                  }}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth>
                <InputLabel required={false} id="desarrollo-label">
                  Apellido Materno
                </InputLabel>

                <CustomInput
                  id="apellidoM"
                  disabled={loading}
                  onChange={e => {
                    inputChange(e);
                  }}
                  formControlProps={{
                    fullWidth: true
                  }}
                  labelProps={{
                    required: true
                  }}
                  inputProps={{
                    maxLength: 50
                  }}
                  attributes={{
                    value: apellidoM
                  }}
                />
              </FormControl>
            </Grid>
          </Grid>
          
          <Grid container spacing={2} style={{ marginTop: 16, marginBottom: 24 }}>
            <Grid item>
              <Button
                disabled={loading}
                className={buttonClassname}
                onClick={e => {
                  handleButtonClick();
                  setHighlightedClientId(null);
                  handeSubmit(e);
                }}
                color="primary"
              >
                Consultar
              </Button>
            </Grid>
            <Grid item>
              <Button
                disabled={loading}
                className={buttonClassnameLimpiar}
                onClick={e => {
                  handleButtonClick();
                  limpiar(e);
                }}
              >
                Limpiar formulario
              </Button>
            </Grid>
            <Grid item>
              <Button
                disabled={loading}
                className={buttonClassnameRegistra}
                color="success"
                onClick={e => {
                  //handleButtonClick();
                  handleClickOpen("", "", "add");
                }}
              >
                Registra Cliente
              </Button>
            </Grid>
          </Grid>
         
          <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            open={opensnackok}
            autoHideDuration={4000}
            onClose={handleClosesSnackOk}
          >
            <Alert onClose={handleClosesSnackOk} severity="success">
              {mensajeSnack}
            </Alert>
          </Snackbar>

          <Snackbar
            place="br"
            open={openSnackError}
            autoHideDuration={6000}
            onClose={handleClosesSnackError}
          >
            <Alert onClose={handleClosesSnackError} severity="error">
              {mensajeERROR}
            </Alert>
          </Snackbar>

          <MaterialTable
            title="Lista de clientes"
            columns={column}
            data={data}
            onRowClick={onRowClick}
            onSelectionChange={onSelectionChange}
            localization={materialTableLocalization}
            options={{
              rowStyle: row => {
                if (highlightedClientId && row.ID_CLIENTE === highlightedClientId) {
                  return { background: "#c8e6c9" };
                }
                if (row?.ID_CLIENTE === selectedRow?.ID_CLIENTE) {
                  return { background: "#e7e7e7" };
                }
                return {};
              }
            }}
          />





        </CardBody>
      </Card>{" "}
      <Dialog
        open={modal}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        maxWidth="md"
        fullWidth
      >
        <DialogTitle id="form-dialog-title">
          {modaltitle}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            {/* Datos Personales */}
            <Grid item xs={12}>
              <Typography variant="subtitle1" className={classes.sectionHeader}>
                Datos Personales
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                id="nombreMod"
                label="Nombre"
                variant="outlined"
                fullWidth
                required
                value={modnombres}
                disabled={loading}
                error={!!formErrors.nombre}
                helperText={formErrors.nombre}
                onChange={e => {
                  inputChangeModal(e);
                }}
                inputProps={{ maxLength: 50 }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                id="apellidoPmod"
                label="Apellido Paterno"
                variant="outlined"
                fullWidth
                required
                value={modapellidoP}
                disabled={loading}
                error={!!formErrors.apellidoP}
                helperText={formErrors.apellidoP}
                onChange={e => {
                  inputChangeModal(e);
                }}
                inputProps={{ maxLength: 50 }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                id="apellidoMmod"
                label="Apellido Materno"
                variant="outlined"
                fullWidth
                value={modapellidoM}
                disabled={loading}
                onChange={e => {
                  inputChangeModal(e);
                }}
                inputProps={{ maxLength: 50 }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel id="sexo-label">Sexo</InputLabel>
                <Select
                  labelId="sexo-label"
                  id="sexo"
                  value={sexo}
                  disabled={loading}
                  onChange={handleChangesexo}
                  label="Sexo"
                >
                  <MenuItem value={"M"}>Masculino</MenuItem>
                  <MenuItem value={"F"}>Femenino</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  disabled={loading}
                  margin="normal"
                  id="date-picker-dialog"
                  label="Fecha de nacimiento"
                  format="dd/MM/yyyy"
                  required
                  fullWidth
                  inputVariant="outlined"
                  maxDate={new Date(new Date().getFullYear() - 18, new Date().getMonth(), new Date().getDate())}
                  maxDateMessage="El cliente debe ser mayor de 18 años"
                  value={fechainicioservicio}
                  onChange={date => {
                    handledfechainicioservicio(date);
                    validateField("fechaNacimiento", date);
                  }}
                  error={!!formErrors.fechaNacimiento}
                  helperText={formErrors.fechaNacimiento}
                  KeyboardButtonProps={{
                    "aria-label": "cambiar fecha"
                  }}
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                id="claveElectormod"
                label="Clave elector"
                variant="outlined"
                fullWidth
                required
                value={modClaveElector}
                disabled={loading}
                error={!!formErrors.claveElector}
                helperText={formErrors.claveElector}
                onChange={e => {
                  setmodClaveElector(e.target.value);
                  validateField("claveElector", e.target.value);
                }}
                inputProps={{ maxLength: 18 }}
              />
            </Grid>

            {/* Contacto */}
            <Grid item xs={12}>
              <Typography variant="subtitle1" className={classes.sectionHeader}>
                Contacto
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                id="telFijoMod"
                label="Teléfono fijo"
                variant="outlined"
                fullWidth
                value={modTelefono}
                disabled={loading}
                error={!!formErrors.telefonoFijo}
                helperText={formErrors.telefonoFijo}
                onChange={e => {
                  inputChangeModal(e);
                }}
                inputProps={{ maxLength: 12 }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                id="telMovilMod"
                label="Teléfono móvil"
                variant="outlined"
                fullWidth
                value={modTelefonoMov}
                disabled={loading}
                error={!!formErrors.telefonoMovil}
                helperText={formErrors.telefonoMovil}
                onChange={e => {
                  inputChangeModal(e);
                }}
                inputProps={{ maxLength: 12 }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="emailmod"
                label="Correo electrónico"
                variant="outlined"
                fullWidth
                value={modEmail}
                disabled={loading}
                error={!!formErrors.email}
                helperText={formErrors.email}
                onChange={e => {
                  setmodEmail(e.target.value);
                  validateField("email", e.target.value);
                }}
              />
            </Grid>

            {/* Dirección */}
            <Grid item xs={12}>
              <Typography variant="subtitle1" className={classes.sectionHeader}>
                Dirección
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="direccionMod"
                label="Dirección"
                variant="outlined"
                fullWidth
                value={modDireccion}
                disabled={loading}
                onChange={e => {
                  setmodDireccion(e.target.value);
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button disabled={loading} onClick={handleClose} color="danger">
            Cancelar
          </Button>
          <Button
            variant="contained"
            className={buttonClassname}
            disabled={isAceptarDisabled}
            onClick={e => {
              if (!esUpdate) {
                handleButtonClick();
                insertaCliente(e);
              } else {
                //   console.log("actualizar");
              }
            }}
            color="info"
            type="submit"
          >
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>


 

       
      <ModalLotesCliente modalLote={modalLote}  lotesCliente={lotesCliente} setLotesCliente={setLotesCliente} setModalLote={setModalLote}   
        getMovimientosxLote={getMovimientosxLote} movimientosLote={movimientosLote} setMovimientosLote={setMovimientosLote} 
        getAmortizacionxLote={getAmortizacionxLote} amortizacionxlote={amortizacionxlote} setAmortizacionxLote={setAmortizacionxLote}
      
        />


      {loading && (
        <CircularProgress size={40} className={classes.buttonProgress} />
      )}
    </>
  );
}
